import React from "react";
import Cookies from "universal-cookie";
import "../../../App.css";
import CustomizedTables from "../Components/CustomTable";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import { useNavigate } from "react-router-dom";
const cookies = new Cookies();
const PendingAndHistoryPayment = () => {
  //   constructor() {
  //     super();
  //     this.goHomePage = this.goHomePage.bind(this);
  //   }

  //   componentDidMount() {}
  let navigate = useNavigate();
  const goHomePage = () => {
    let path = "/add_fatora";
    navigate(path);
  };

  if (
    cookies.get("token") &&
    cookies.get("user-type") &&
    cookies.get("user-type") === "1"
  ) {
    return (
      <div className="Doctor-dashboard-div" style={{ color: "#2E5266FF" }}>
        <div className="Doctor-dashboard-heading">
          <div style={{ fontSize: 56 }}>متابعة الضرائب المسجلة</div>
        </div>
        <div
          className="d-flex justify-content-left align-items-center "
          style={{ width: "80%" }}
        >
          <AddCircleOutlineSharpIcon
            onClick={goHomePage}
            style={{ fontSize: 50, margin: "10px", cursor: "pointer" }}
          />
          <span>أضافة فاتورة</span>
        </div>
        <div style={{ width: "80%" }}>
          <h2 style={{ marginTop: 30, fontSize: 20, fontStyle: "bold" }}>
            الفواتر المستحق تسديدها
          </h2>
          <h4 style={{ fontSize: 16 }}>
            .لوريم ايبسوم دولار سيت اميت ودولار سيت اميت ودولار سيت اميت اميت
            اميت اميت اي بالله
          </h4>
        </div>

        <div style={{ width: "80%" }}>
          <CustomizedTables />
        </div>
        <div style={{ width: "80%" }}>
          <h2 style={{ marginTop: 30, fontSize: 20, fontStyle: "bold" }}>
            الفواتير المدفوعة مسبقاً
          </h2>
          <h4 style={{ fontSize: 16 }}>
            .لوريم ايبسوم دولار سيت اميت ودولار سيت اميت ودولار سيت اميت اميت
            اميت اميت اي بالله
          </h4>
        </div>
        <div style={{ width: "80%", marginBottom: 20 }}>
          <CustomizedTables />
        </div>
      </div>
    );
  } else {
    window.location.href = "/";
  }
};

export default PendingAndHistoryPayment;
